import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { PropsBuilder } from '../__base/props-builder';

export class ButtonPropsBuilder extends PropsBuilder<'button'> {
  override setMargin = (margin: string | undefined): this => {
    this.patchProps({ style: { button: { offset: { margin } } } });
    return this;
  };

  constructor(props: PartialPropsOf<'button'> | undefined) {
    super(props, { hasData: false, hasLabel: true });
  }
}
